import React, { Component } from 'react';
import Session from '../services/session';
import navigation from '../navigation';
import i from '../imports';


const StyleContainer = {
    width: 'auto', 
    backgroundColor: "rgb(128, 128, 128)",
}

const StyleNormal = {
    maxWidth: '1170px',
    textShadow: "1px 1px 1px rgb(35, 35, 35)",
    textAlign: "left",
    width: "auto",
    paddingTop: 29,
    paddingBottom: 29,
    transition: 'all 1s',
    fontSize: 20,
    fontWeight: 700,
    color: "rgb(255, 255, 255)",
}

const StyleMobile = {
    ...StyleNormal,
    maxWidth: '750px',
    margin: '0 20px'
}

const StylePhablet = {
    ...StyleNormal,
    maxWidth: '750px',
}

const StyleTablet = {
    ...StyleNormal,
    maxWidth: '870px',
}

const StyleParent = {
    ...StyleNormal,
    textDecoration: "none",
    color: "rgb(216, 89, 98)",
    cursor: 'pointer'
}

class BreadCrumbs extends Component {
    
    render(){

        let md = this.props.md ? this.props.md : 12;
        let xs = this.props.xs ? this.props.xs : 12;

        const paths = parentPaths(this.props.fullpath.substring(3));
        return(
            /*  {paths.map((path) => <a href={i.Utils.locUrl(path)} style={StyleParent}>{getNameByPath(path)} > </a> )}
                {this.props.name ? this.props.name : getNameByPath(this.props.fullpath.substring(3))} 
            */
            // <div style={StyleContainer}>
            //     <i.OnMobile>
            //         <div style={StyleMobile}>
            //             {paths.map((path) => <a href={i.Utils.locUrl(path)} style={StyleParent}>{getNameByPath(path)} > </a> )}
            //             {this.props.name ? this.props.name : getNameByPath(this.props.fullpath.substring(3))} 
            //         </div>
            //     </i.OnMobile>
            //      <i.OnPhablet>
            //         <div style={StylePhablet}>
            //             {paths.map((path) => <a href={i.Utils.locUrl(path)} style={StyleParent}>{getNameByPath(path)} > </a> )}
            //             {this.props.name ? this.props.name : getNameByPath(this.props.fullpath.substring(3))} 
            //         </div>
            //     </i.OnPhablet> 
            //     <i.OnTablet>
            //         <div style={StyleTablet}>
            //             {paths.map((path) => <a href={i.Utils.locUrl(path)} style={StyleParent}>{getNameByPath(path)} > </a> )}
            //             {this.props.name ? this.props.name : getNameByPath(this.props.fullpath.substring(3))} 
            //         </div>
            //     </i.OnTablet>
            //     <i.OnDesktop>
            //         <div style={StyleNormal}>
            //             {paths.map((path) => <a href={i.Utils.locUrl(path)} style={StyleParent}>{getNameByPath(path)} > </a> )}
            //             {this.props.name ? this.props.name : getNameByPath(this.props.fullpath.substring(3))} 
            //         </div>
            //     </i.OnDesktop>
            // </div>
            <div style={StyleContainer} >
                <i.PureGridProvider>
                    <i.Container>
                        <i.Row justify='center'>
                            <i.Col md={md} align='left' style={StyleNormal} >
                            {paths.map((path) => <a href={i.Utils.locUrl(path)} style={StyleParent}>{getNameByPath(path)} > </a> )}
                            {this.props.name ? this.props.name : getNameByPath(this.props.fullpath.substring(3))} 
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </i.PureGridProvider>
            </div>
        );
    };

};

const parentPaths =(path) =>{

    const paths = [];
    let currentPath = path;
    do {
        currentPath = path.substring(0, currentPath.lastIndexOf('/'));
        if(currentPath.includes("/city") )
            currentPath = path.substring(0, currentPath.lastIndexOf('/'));
        if(currentPath !== "")
            paths.push(currentPath);
    } while(currentPath !== "");

    return paths.reverse();
}



const getNameByPath = (path) =>{

    var navigationElement;
    let modelName ="";
    var name = "";


    if(path.lastIndexOf('/') === 0){
        navigationElement = navigation.filter(n => n.path === path);
        name = navigationElement[0].name;

        modelName = Session.model.navigation[name];
    }else{
        let navigationParent = navigation.filter(n => n.path === path.substring(0, path.lastIndexOf('/')));
        let parentName = navigationParent[0].name;

        navigationElement = navigationParent[0].children;

        if(navigationElement) {
            navigationElement = navigationParent[0].children.filter(n => n.path === path);
            name = navigationElement[0].name;
            modelName = Session.model.navigation[parentName + 'Children'][name];
        }
        

    }
    return modelName;
}

export default BreadCrumbs;